import { Component, OnInit } from '@angular/core';
import { Router, Event, NavigationEnd } from '@angular/router';

import { AuthService } from './../services/auth.service';
import { LanguageService } from './../rest/api/language.service';
import * as _ from 'lodash';
import { PageService } from '../rest/api/page.service';
import {TranslateService} from '@ngx-translate/core';
import { SettingService } from '../rest/api/setting.service';

@Component({
  selector: 'app-main-footer',
  templateUrl: './main-footer.component.html',
  styleUrls: ['./main-footer.component.scss']
})
export class MainFooterComponent implements OnInit {
  fooMenu: any;
  currentUrl = '';
  userData: any;
  lang: any;
  socialList: any;
  rla: any;

  defaultLanguage: any;
  languageData: any;
  constructor(
    public languageService: LanguageService,
    public pageService: PageService,
    public settingService: SettingService,
    public translateService: TranslateService
  ) { }

  ngOnInit() {
    this.lang = this.translateService.currentLang ? this.translateService.currentLang :
    (localStorage.getItem('language') ? localStorage.getItem('language') : '');
    this.getFooterMenu();
    this.getSocialList();
  }
  getFooterMenu() {
    this.pageService.getMenuList(this.lang).subscribe((response: any) => {
    let fooMenu = response.data;
    fooMenu = _.filter(fooMenu, {show_in_footer: 1});
    this.fooMenu = _.orderBy(fooMenu,  ['position'], ['asc']);
   }, err => {
     console.log(err && err.error);
   });
  }
  getSocialList() {
    this.settingService.getSettingDetails().subscribe((response: any) => {
      this.socialList = response.data;
    }, err => {
      console.log(err && err.error);
    });
  }
}
